import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

export default function SkeletonFooter(): JSX.Element {
  return <Skeleton variant="rect" height={212.96} width="100%" />
}
